module.exports = __webpack_public_path__ + "img/outline2.f39c1502.svg";